// extracted by mini-css-extract-plugin
export default {"SecondNavbar":"SecondNavbar_SecondNavbar__SX7-o"};